var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.teams),function(team){return _c('team',{key:team.id,attrs:{"team":team}})}),_vm._v(" "),_c('button',{staticClass:"add-content-button",on:{"click":function($event){$event.preventDefault();return _vm.openFolderModal($event)}}}),_vm._v(" "),_c('folder-modal')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0bfdfec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/folders/FoldersPage.vue
// module id = null
// module chunks = 